import { useSelector } from 'react-redux'

const useAppPreferences = () => {
  const { appPreferences, isLoading, error } = useSelector(state => state.appPreferences)
  return { preferences: appPreferences, isLoading, error }
}

export default useAppPreferences
